import {HTTP_STATUS} from '../consts';

export const getErrorStatusCode = error => error?.status ?? HTTP_STATUS.SOMETHING_WENT_WRONG;
